const decimalOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
const decimalFormatter = new Intl.NumberFormat('ru-RU', decimalOptions)
const rubleFormatter = new Intl.NumberFormat('ru-RU', { ...decimalOptions, style: 'currency', currency: 'RUB' })

// Presentation only: keep decimal strings intact so formatting does not first
// lose cents through a Number conversion for large saved amounts.
export function formatMoney(value, options = {}) {
  const { currency = '', empty = '—', invalid = '—', useGrouping = true } = options
  if (value === null || value === undefined) return empty
  const raw = String(value).replace(/\s/g, '').replace(',', '.')
  if (!raw) return empty
  if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i.test(raw) || !Number.isFinite(Number(raw))) return invalid

  let parts
  try {
    let formatter = decimalFormatter
    if (currency === 'RUB' && useGrouping) formatter = rubleFormatter
    else if (currency || !useGrouping) {
      formatter = new Intl.NumberFormat('ru-RU', {
        ...decimalOptions,
        useGrouping,
        ...(currency ? { style: 'currency', currency } : {})
      })
    }
    parts = formatter.formatToParts(raw)
  } catch {
    return invalid
  }
  const roundedZero = parts.filter((part) => part.type === 'integer' || part.type === 'fraction')
    .every((part) => /^0+$/.test(part.value))
  return parts.filter((part) => !(roundedZero && part.type === 'minusSign')).map((part) => part.value).join('')
}
